import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=69bdbe54&scoped=true"
import script from "./TermsModal.vue?vue&type=script&lang=ts"
export * from "./TermsModal.vue?vue&type=script&lang=ts"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=69bdbe54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bdbe54",
  null
  
)

export default component.exports